<template>
  <van-row  >
    <div class="item-content model-content" >
      <van-col :span='6' ><img  :src="modelImgUrl" /></van-col>
      <van-col :span='15' >
          <template slot="default">
              <div class="comparsion-li-title clearfix line-height-1">
                <div class="model-item-value model-item-name">{{modelData.name}}</div>
                <ul>
                  <li>
                    <div class="model-item-title" :style="{width: LumenStyle}">{{$t('T_INFO_BRIGHTNESS')}}</div>
                    <div class="model-item-value">{{modelData.color}}{{$t('T_LUMEN')}}</div>
                  </li>
                  <li>
                    <div class="model-item-title" :style="{width: InfoStyle}">{{$t('T_INFO_RESOLUTION')}}</div>
                    <div class="model-item-value">{{modelData.resolution}}</div>
                  </li>
                  <li>
                    <div class="model-item-title" :style="{width: LensStyle}">{{ $t('T_LENS_SHIFT') }}</div>
                    <div class="model-item-value">{{modelData.lensShiftAvailable}}</div>
                  </li>
                </ul>
              </div>
          </template>
      </van-col>
      <van-col :span='2' class="model-select">
        <van-button type="info" @click="change" :class="btnClass" >{{$t('T_MORE')}}</van-button>
      </van-col>
    </div>
  </van-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'modelItem',
  data () {
    return {
    }
  },

  props: ['modelData'],
  methods: {
    change () {
      this.$emit('onModelChange', this.modelData)
    }
  },
  computed: {
    ...mapState(['language']),
    modelImgUrl () {
      console.log(process.env.BASE_URL)
      let url = this.modelData.url.replace('static/', "./")
      return url + '.jpg'
    },
    InfoStyle () {
      if (screen.width === 320 && (this.language === 'lt' || this.language === 'it' || this.language === 'es' || this.language === 'pl')) {
        return '1.4rem'
      } else if (screen.width === 320 && (this.language === 'fr')) {
        return '1rem'
      } else {
        return 'auto'
      }
    },
    LensStyle () {
      if (screen.width === 320 && this.language === 'fr') {
        return '3rem'
      } else if (screen.width === 320 && this.language === 'es') {
        return '3rem'
      } else if (screen.width === 320 && (this.language === 'bg' || this.language === 'pl')) {
        return '2.6rem'
      } else if (screen.width === 320 && (this.language === 'ja' || this.language === 'no' || this.language === 'cs')) {
        return 'auto'
      } else {
        return '2rem'
      }
    },
    LumenStyle () {
      if (screen.width === 320 && this.language === 'ja') {
        return '2rem'
      } else if (screen.width === 320 && (this.language === 'fr')) {
        return '1.3rem'
      } else {
        return ''
      }
    },
    btnClass () {
      if (this.language === 'fr' || this.language === 'de' || this.language === 'it' || this.language === 'pt-PT') {
        return 'btnContenthei'
      } else if (this.language === 'es' || this.language === 'nl' || this.language === 'hu' || this.language === 'pl' ||
      this.language === 'bg' || this.language === 'lt' || this.language === 'ro' || this.language === 'el' || this.language === 'hr' || this.language === 'sr') {
        return 'btnContentEs'
      } else {
        return 'btnContent'
      }
    }
  },
  mounted () {

  },
  components: {
  }
}
</script>

<style scoped>
  .van-cell {
    padding: 0;
    display: table;
  }

  .van-cell__right-icon {
    display: table-cell;
    vertical-align: middle;
    text-align: right;
  }
  .item-content{
    height: 80px;
    border-bottom:0.5px solid #e3e3e3;
    padding:10px 0;

  }
  img{
    border:1px solid #ccc;
    width: 60px;
    height: 60px;
  }
  .van-progress{
    border-radius: 0;
    height: 2px;
  }
  .item-content .van-col--6{
    width: 69px
  }
  .item-content .van-col--15{
    width:6.2rem
  }
</style>
